import type { RootStateOrAny as State } from 'react-redux';
import { createSelector } from 'reselect';
import { getProductDetailsById } from '@americanexpress/product-ducks';
import { MODULE_NAME } from './constants';

export const getLocale = (state: State): string =>
  state.getIn(['intl', 'activeLocale']);

export type GetForProduct<R> = (accountToken: string) => (state: State) => R;

export const getMemberName: GetForProduct<string> = (accountToken) => createSelector(
  (state) => getProductDetailsById(state, accountToken),
  (details) => details.profile.embossed_name
);

export const getMemberFirstName: GetForProduct<string> = (accountToken) => createSelector(
  (state) => getProductDetailsById(state, accountToken),
  (details) => details.profile.first_name
);

export const getMemberSinceYear: GetForProduct<string> = (accountToken) => createSelector(
  (state) => getProductDetailsById(state, accountToken),
  (details) => details.profile.member_since_date.slice(2, 4)
);

export const getProductBusinessType: GetForProduct<string> = (accountToken) => createSelector(
  (state) => getProductDetailsById(state, accountToken),
  (details) => details?.product?.line_of_business_type
);

export const getPublicGuid = (state: State) =>
  state.getIn(['browser', 'cookies', 'blueboxpublic']);

export const getPreferredNotShown = (state: State): boolean =>
  state.getIn(['modules', MODULE_NAME, 'preferNotShown'], false);
